import React, { useState } from "react";
import { Row, Col, Button } from "antd";
import "./index.css"

const ValidateUser = ({ backgroundImage, brokentLinkImage, trkrDescription, trkrText, emptyTowerImage, exitsText, isShowButton, ImageWidth, ImageHeight, onhandleClick }) => {
    return (
        <Row justify="center">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row justify="center" >
                    <Col span={24} className="not-found-container" style={{ backgroundImage: `url(${backgroundImage})`, }}>
                        <Row>
                            <Col span={24} className="not-found-container page-content">
                                <img src={brokentLinkImage} width={ImageWidth} height={ImageHeight} style={{ marginTop: '50px' }} />
                                <h3 className="opps-font">{trkrText}</h3>
                                <h5 className="description-font">{trkrDescription}</h5>
                                <span className="page-content notfound-message">
                                    <img src={emptyTowerImage} style={{ marginTop: '50px' }} />
                                    <h3 className="trkttower-font">
                                        {exitsText}
                                    </h3>
                                    {isShowButton &&
                                        <button className="btn btn-flat teal-text" onClick={() => window.open(`${process.env.REACT_APP_LINK}://app${process.env.REACT_APP_DOMAIN}/#/customer/rmx`)}>GO TO HOMEPAGE</button>
                                    }
                                </span>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col >
        </Row >

    )
}

export default ValidateUser
